/**
 * Avg、Sum、Max 跟 指标组合的 翻译
 * 由于 这种翻译没有固定的规律，翻译后的中文无规律可循
 * 比如
 * PCU 对应的中文 是 最高同时在线玩家
 * MAX PCU 对应的中文 还是 最高同时在线玩家
 * 所以 就不做动态组合了，直接写死，后面产品想改文案 随便怎么改 都还弄
 *
 * 这里的key格式为 dbi_calc_metric_计算的方式_指标
 * dbi_calc_metric为固定前缀，方便跟其他中英文翻译key区分开
 * 计算方式为 max、avg、sum等
 *
 * REMARK: 统一拼接翻译key 请引用src/pages/intelligence/utils/calcMetric.ts 文件中的 getCalcMetricTranslateKey方法 统一组装翻译的key
 */
export default {
  // dbi_calc_metric_max_pcu: '最高同时在线玩家',
  // dbi_calc_metric_avg_acu: '同时在线玩家人数平均值',
  dbi_calc_metric_max_pcu: 'Max PCU',
  dbi_calc_metric_avg_acu: 'Avg ACU',
  dbi_calc_metric_avg_mau: '月活用户平均值',
  dbi_calc_metric_avg_wau: '周活用户平均值',
  dbi_calc_metric_sum_digital_revenue: '线上收入(美元）汇总值',
  dbi_calc_metric_sum_units: '销量汇总值',
  dbi_calc_metric_avg_ast: '单笔交易消费均值',
  dbi_calc_metric_avg_digital_arppu: '线上付费玩家人均平均消费(美元) (仅美国)',
  dbi_calc_metric_sum_physical_revenue: '零售收入（美元）汇总值',

  dbi_calc_metric_avg_dau: '日活用户平均值',
  dbi_calc_metric_avg_revenue: '收入平均值',
  dbi_calc_metric_avg_downloads: '下载平均值',
  dbi_calc_metric_sum_dau: '日活用户汇总至',
  dbi_calc_metric_sum_wau: '周活用户汇总至',
  dbi_calc_metric_sum_mau: '月活用户汇总至',
  dbi_calc_metric_sum_revenue: '收入汇总值',
  dbi_calc_metric_sum_downloads: '下载汇总值',
};
